// stompClientService.js
import * as StompJs from '@stomp/stompjs';

const MAX_RECONNECT = 6;

class StompClientService {

    constructor() {
        if (StompClientService._instance) {
            return StompClientService._instance;
        }
        this.stompClient = null;
        this.connected = false;
        this.reconnectAttempt = 0;
        this.reconnecting = false;

        StompClientService._instance = this;
    }

    connect(accessToken, onPrivateMessage, onGroupMessage, onDeliver, onSeen, onConnected) {
        if (this.connected) return;
        if (this.stompClient && this.stompClient.active) return;

        this.stompClient = new StompJs.Client({
            brokerURL: `${import.meta.env.VITE_APP_WEBSOCKET_URL}?token=${accessToken}`,
           debug: (str) => console.log('STOMP:', str),
            beforeConnect: (frame) => {
                //console.log("before connect", frame);
            },
            discardWebsocketOnCommFailure: true,
            reconnectDelay: 0,
            heartbeatIncoming: 10000,
            heartbeatOutgoing: 10000,
            onConnect: (frame) => {
                this.connected = true;
                this.reconnectAttempt = 0;
                this.reconnecting = false;
                // Subscribe to private queue
                this.stompClient.subscribe(`/user/queue/messages`, (message) => {
                    //console.log('Private Message:', message.body);
                    onPrivateMessage(JSON.parse(message.body));
                });


                this.stompClient.subscribe(`/user/queue/group/messages`, (message) => {
                   // console.log('Group Message:', message.body);
                    onGroupMessage && onGroupMessage(JSON.parse(message.body));
                });

                this.stompClient.subscribe(`/user/queue/deliver/messages`, (message) => {
                    // console.log('Group Message:', message.body);
                    onGroupMessage && onDeliver(JSON.parse(message.body));
                });

                this.stompClient.subscribe(`/user/queue/seen/messages`, (message) => {
                    // console.log('Group Message:', message.body);
                    onGroupMessage && onSeen(JSON.parse(message.body));
                });
        
                if (onConnected && typeof onConnected === "function") {
                    onConnected();
                }
            },
            onDisconnect: () => {
                this.connected = false;
                this.stompClient = null;
                this.reconnectAttempt = 0;
            },
            onStompError: (frame) => {
                this.connected = false;
                this.stompClient = null;
                console.error('STOMP Error:', frame.headers['message']);
                console.error('Details:', frame.body);
                this.scheduleReconnect(accessToken, onPrivateMessage, onGroupMessage);
            },
            onWebSocketClose: (evt) => {
                this.connected = false;
                this.stompClient = null;
              // console.log('WebSocket closed:', evt);
                // this.scheduleReconnect(accessToken, onPrivateMessage, onGroupMessage)
            },
            onWebSocketError: (evt) => {
                this.connected = false;
                this.stompClient = null;
                console.error('WebSocket error:', evt);
                this.scheduleReconnect(accessToken, onPrivateMessage, onGroupMessage)
            }
        });

        if (accessToken) {
            this.stompClient.activate();
        }
    }
    scheduleReconnect(accessToken, onPrivateMessage, onGroupMessage) {
        if (this.connected || this.reconnecting) {
            return;
        }
        if (this.stompClient && this.stompClient.active) return;
        this.reconnecting = true;
        if (this.reconnectAttempt >= MAX_RECONNECT) {
            this.reconnecting = false;
            return;
        };

        setTimeout(() => {
           // console.log("reconnect attemp........", this.reconnectAttempt);
            this.reconnecting = false;
            this.connect(accessToken, onPrivateMessage, onGroupMessage);
            this.reconnectAttempt++;
        }, 5000);
    }
    disconnect() {
        if (this.stompClient && this.stompClient.active) {
            this.stompClient.deactivate();
            //console.log("CLient disconnected");

            this.stompClient = null;
            this.connected = false;
        }
    }

    getClient() {
        return this.stompClient;
    }

    isConnected() {
        return this.stompClient?.active ?? false;
    }
}

// Export a single instance
export const stompClientService = new StompClientService();